import { Subject } from 'rxjs'

export const closeEndCoopEventEmitter = new Subject()
